import { render, staticRenderFns } from "./transactionsList.vue?vue&type=template&id=1addd575&scoped=true"
import script from "./transactionsList.vue?vue&type=script&lang=js"
export * from "./transactionsList.vue?vue&type=script&lang=js"
import style0 from "./transactionsList.vue?vue&type=style&index=0&id=1addd575&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1addd575",
  null
  
)

export default component.exports